import { useState, useEffect, useRef } from 'react';

import { ReactComponent as TrashIcon } from '@/assets/icons/bx-trash.svg';

//import { useAccount } from './AccountContext';
import { ReactComponent as DotsHorizontalIcon } from './assets/bx-dots-horizontal-rounded.svg';
import EditImage from './assets/bx-edit-alt.svg';
import { DeleteModal } from './modals/DeleteModal';

interface Props {
  modalText: string;
  listType: 'measure' | 'post' | 'project';
  deleteFunction: () => void;
  editFunction?: () => void;
}

export default function DotsDropdown(props: Props): React.ReactElement {
  const [isActive, setIsActive] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const insideRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const el = insideRef.current;
    if (!el) return;

    const handleClickOutside = (e: MouseEvent) => {
      if (!el?.contains(e.target as Node)) {
        setIsActive(false);
      } else {
        return;
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [insideRef]);

  // listType を DeleteModal の型に変換
  const getDeleteModalType = (): 'post' | 'image' | 'content' | 'project' => {
    if (props.listType === 'measure') {
      return 'project'; // measure を project に変換
    }
    return props.listType;
  };

  return (
    <div className="relative inline-block text-left">
      <button
        ref={insideRef}
        className="h-[25px] w-[24px] gap-x-1.5 text-sm font-medium leading-5 text-gray-700"
        onClick={() => setIsActive(!isActive)}
      >
        <DotsHorizontalIcon />
      </button>
      {isActive && (
        <div className="absolute right-0 top-0 z-10 mt-[28px] w-[128px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-[0.05] focus:outline-none">
          {props.listType !== 'post' && (
            <div className="py-2 pl-3">
              <a href="#" onClick={props.editFunction}>
                <div className="flex items-center">
                  <div>
                    <img src={EditImage} alt="" />
                  </div>
                  <div className="pl-3 text-sm text-gray-700">編集する</div>
                </div>
              </a>
            </div>
          )}
          <div className="py-2 pl-4">
            <a href="#" onClick={() => setIsDeleteOpen(true)}>
              <div className="flex items-center">
                <TrashIcon className="h-5 w-5 fill-red-600" aria-hidden="true" />
                <div className="pl-3 text-sm text-red-600">削除する</div>
              </div>
            </a>
          </div>
        </div>
      )}
      {/* 削除モーダル */}
      <DeleteModal
        type={getDeleteModalType()}
        open={isDeleteOpen}
        handleDelete={() => {
          props.deleteFunction(); // 削除ロジックを実行
          setIsDeleteOpen(false);
        }}
        handleCancel={() => setIsDeleteOpen(false)}
      />
    </div>
  );
}
